import { render, staticRenderFns } from "./sharedSpaceList.vue?vue&type=template&id=bbc4b77a&scoped=true&"
import script from "./sharedSpaceList.vue?vue&type=script&lang=js&"
export * from "./sharedSpaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4b77a",
  null
  
)

export default component.exports